module.exports = __webpack_public_path__ + "static/media/EventPhoto4.a67976a3.jpg";